export default __webpack_public_path__ + "static/media/auto_distribute.cdefbe68.png";